// extracted by mini-css-extract-plugin
export default {"root":"vW8vNx","mobile":"P2vOW9"};